<div class="db-create-migrate">
  <div class="db-create-migrate__title hide-mobile" [innerHTML]="'text_chooseProceed' | dbText"></div>
  <div class="db-create-migrate__content">
    <div class="db-create-migrate__card">
      <div class="db-create-migrate__title" [innerHTML]="'text_createNewWPWebsite' | dbText"></div>
      <div class="db-create-migrate__card-body db-create-migrate__create">
        <div class="db-create-migrate__card-body_item">
          <i class="db-icon db-icon-checkbox-round"></i>{{'text_recreateWithAi' | dbText}}
        </div>
        <div class="db-create-migrate__card-body_item">
          <i class="db-icon db-icon-checkbox-round"></i>{{'text_builderBasedElementor' | dbText}}
        </div>
        <div class="db-create-migrate__card-body_item">
          <i class="db-icon db-icon-checkbox-round"></i>{{'text_useThemePlugin' | dbText}}
        </div>
      </div>
      <div class="db-create-migrate__buttons-wrap">
        <a class="db-button db-button_yellow" (click)="openDialog.emit('create')" [ngClass]="{'db-disabled': false}"><span>create now</span></a>
      </div>
    </div>
    <div class="db-create-migrate__separator"><span>or</span></div>
    <div class="db-create-migrate__card">
      <div class="db-create-migrate__title" [innerHTML]="'text_automatedMigration' | dbText"></div>
      <div class="db-create-migrate__subtitle" [innerHTML]="'text_copyWithoutAffectingWebsite' | dbText"></div>
      <div class="db-create-migrate__card-body">
        <div class="db-create-migrate__card-body_item">
          <i class="db-icon db-icon-checkbox-round"></i>
          <div>
            {{'text_ltd_connect_website_popup_step1' | dbText}}
            <a class="db-button db-button_yellow db-create-migrate__download"
               href="{{managerLink}}" (click)="downloadManagerPlugin()" download>
              <i class="db-icon db-icon-download-button"></i>
              <span class="db-ab-test-link" [innerHTML]="'text_addWebsiteManuallyStep1Title' | dbText"></span>
            </a>
          </div>
        </div>
        <div class="db-create-migrate__card-body_item">
          <i class="db-icon db-icon-checkbox-round"></i>{{'text_installActivatePluginWP' | dbText}}
        </div>
      </div>
    </div>
  </div>
  <div class="db-create-migrate__footer" [innerHTML]="'text_anyHostedGet90score' | dbText"></div>
</div>
